// ── Shared notification deep-link resolver (NOTIF.4 · D-NOTIF-4-1/4-3) ────────
//
// One mechanism for BOTH the notification center and the bell. Maps a store
// notification's (resource_type, resource_id) to a frontend detail route.
//
// Safety rule (D-NOTIF-4-3): an unmapped resource_type OR a null resource_id
// returns null → the caller renders a disabled/no-op affordance, NEVER a broken
// navigation. No click can produce a dead route.

const RESOURCE_ROUTE: Record<string, (id: string) => string> = {
  assessment: (id) => `/assessments/${id}`,
  risk_acceptance: (id) => `/risk-acceptances/${id}`,
  org_risk_acceptance: (id) => `/org-risk-acceptances/${id}`,
};

/** Resolve a notification's deep-link route, or null if it cannot be navigated. */
export function resolveNotificationRoute(
  resourceType: string | null | undefined,
  resourceId: string | null | undefined,
): string | null {
  if (!resourceId || !resourceType) return null;
  const build = RESOURCE_ROUTE[resourceType];
  return build ? build(resourceId) : null;
}
